<template>
  <div class="actions">
    <BbBtn class="collection-button" size="small" type="secondary" @click="$emit('add-to-collection')">
      <BbIcon size="small" name="collection" />
      <TextBody tag="span" i18n-key="collections.addToCollection" weight="medium" />
    </BbBtn>
    <BbBtn size="small" type="secondary" @click="$emit('translate')">
      <BbIcon size="small" name="translate" />
      <TextBody tag="span" i18n-key="common.translate" weight="medium" />
    </BbBtn>

    <BbBtn size="small" type="secondary" @click="$emit('show-details')">
      <BbIcon size="small" name="slides" />
      <TextBody tag="span" i18n-key="common.showDetails" weight="medium" />
    </BbBtn>
  </div>
</template>

<script>
import TextBody from '~/components/common/TextBody';

export default {
  name: 'ReferenceCardActions',
  components: { TextBody },
  emits: ['add-to-collection', 'translate', 'show-details'],
};
</script>

<style lang="scss" scoped>
.actions {
  display: flex;
  gap: $bb-spacing-1;
  padding: $bb-spacing-2 0;
  width: 100%;
  align-items: center;
  background-color: $bb-neutral-0;

  button {
    flex-grow: 1;
  }

  .collection-button {
    background: $bb-neutral-6;
    border: none !important;
  }

  :deep(.v-btn__content) {
    gap: $bb-spacing-1;
  }
}
</style>
